import { useState, useEffect } from 'react';
import * as CollectionAPI from '../services/CollectionAPI';

const MIGRATION_KEY = 'pockedex_migrated';

const LocalStorageMigration = () => {
  const [showPrompt, setShowPrompt] = useState(false);
  const [migrating, setMigrating] = useState(false);
  const [cardCount, setCardCount] = useState(0);

  useEffect(() => {
    // Skip if already migrated
    if (localStorage.getItem(MIGRATION_KEY)) return;

    // Check if there's existing collection data in localStorage
    const raw = localStorage.getItem('pokemonCollection');
    if (!raw) return;

    try {
      const collection = JSON.parse(raw);
      const count = Object.keys(collection).length;
      if (count > 0) {
        setCardCount(count);
        setShowPrompt(true);
      }
    } catch {
      // No valid data, skip
    }
  }, []);

  const handleMigrate = async () => {
    setMigrating(true);
    try {
      const collection = JSON.parse(localStorage.getItem('pokemonCollection') || '{}');
      const packStats = JSON.parse(localStorage.getItem('pockedexPackStats') || '{}');
      const settings = JSON.parse(localStorage.getItem('pockedexSettings') || '{}');

      await CollectionAPI.importCollection({ collection, packStats, settings });

      // Mark as migrated and clean up
      localStorage.setItem(MIGRATION_KEY, 'true');
      localStorage.removeItem('pokemonCollection');
      localStorage.removeItem('pockedexPackStats');
      localStorage.removeItem('pockedexSettings');

      setShowPrompt(false);
      // Reload to pick up the imported data
      window.location.reload();
    } catch (err) {
      console.error('Migration failed:', err);
      alert('Migration failed. Your local data is still safe.');
    } finally {
      setMigrating(false);
    }
  };

  const handleSkip = () => {
    localStorage.setItem(MIGRATION_KEY, 'true');
    setShowPrompt(false);
  };

  if (!showPrompt) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6">
        <h2 className="text-xl font-bold text-gray-900 mb-2">Existing Collection Found</h2>
        <p className="text-gray-600 mb-4">
          We found <span className="font-semibold text-blue-600">{cardCount} cards</span> saved
          in your browser from before. Want to import them into your account?
        </p>
        <div className="flex gap-3">
          <button
            onClick={handleMigrate}
            disabled={migrating}
            className="flex-1 py-2.5 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50"
          >
            {migrating ? 'Importing...' : 'Import Collection'}
          </button>
          <button
            onClick={handleSkip}
            disabled={migrating}
            className="flex-1 py-2.5 bg-gray-100 text-gray-700 font-medium rounded-lg hover:bg-gray-200 transition-colors disabled:opacity-50"
          >
            Start Fresh
          </button>
        </div>
      </div>
    </div>
  );
};

export default LocalStorageMigration;
